const article = {
  id: "presave-yandex-music-kak-nastroit",
  metaTitle: "Пресейв в Яндекс Музыке: как настроить и сколько нужно",
  metaDescription: "Что такое пресейв, как создать ссылку в BandLink по шагам, где её распространять, сколько сохранений имеет смысл собирать и за сколько дней запускать кампанию.",
  type: "Гайд",
  category: "Музыка",
  title: "Пресейв: как настроить, сколько нужно и когда запускать",
  time: 7,
  data: "31.07.2026",
  imageUrl: "/blogImages/presave-yandex-music-kak-nastroit/backgroundImage.svg",
  hasDescriptionHeader: true,
  description: `Практическое руководство по предварительным сохранениям:
  что происходит с пресейвом в день релиза, как создать ссылку в BandLink,
  где её размещать и почему на вопрос «сколько пресейвов нужно» честный ответ
  звучит как «официального порога не существует».`,
  navigation: [
    { to: "chto-takoe-presave", text: "Что такое пресейв" },
    { to: "kak-sozdat-ssylku", text: "Как создать ссылку в BandLink" },
    { to: "gde-rasprostranyat", text: "Где распространять ссылку" },
    { to: "skolko-nuzhno", text: "Сколько пресейвов нужно" },
    { to: "kogda-zapuskat", text: "Когда запускать" },
    { to: "den-reliza", text: "День релиза и после" },
    { to: "oshibki", text: "Частые ошибки" },
    { to: "korotko", text: "Коротко" },
  ],
  section: [
    {
      id: "chto-takoe-presave",
      title: "Что такое пресейв",
      content: [
        {
          type: "Definition",
          title: "Пресейв",
          text: " — предварительное сохранение релиза, который ещё не вышел. Артист создаёт специальную ссылку и распространяет её заранее; слушатель переходит и нажимает «сохранить».",
        },
        {
          type: "Description",
          text: "В момент публикации релиз автоматически появляется у слушателя: получает лайк и попадает в коллекцию. Все накопленные сохранения срабатывают одновременно, в первые минуты после выхода.",
        },
        {
          type: "Description",
          text: "Именно в этом смысл инструмента. Прослушивания можно набирать когда угодно, но неделю спустя алгоритм уже составил представление о треке. Пресейв существует только до даты релиза — после выхода эта возможность просто исчезает, и заказать её задним числом нельзя.",
        },
        {
          type: "Description",
          text: "По данным BandLink, пресейв поддерживается для Яндекс Музыки, VK Музыки, Spotify и Apple Music. Ссылка при этом одна — слушатель сам выбирает свою площадку.",
        },
        {
          type: "Footnote",
          textItalic: "Отдельная витрина, доступная только до выхода: релизы с наибольшим числом сохранений попадают в подборку «Топ ожиданий» в Яндекс Музыке и «Самые ожидаемые релизы» в VK Музыке.",
        },
      ],
    },
    {
      id: "kak-sozdat-ssylku",
      title: "Как создать ссылку в BandLink",
      content: [
        {
          type: "Description",
          parts: [
            "BandLink — платформа Яндекса, через которую артисты работают с релизами. Порядок действий описан в ",
            { href: "https://yandex.ru/support/music/ru/performers-and-copyright-holders/presave", text: "справке Яндекс Музыки" },
            ", по шагам он выглядит так.",
          ],
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ol",
          items: [
            { bold: "Зарегистрироваться и верифицировать артиста. ", text: "Без верификации недоступны ни аналитика, ни часть инструментов. Карточка артиста создаётся автоматически после первого релиза, верификация — отдельный шаг." },
            { bold: "Дождаться появления релиза в кабинете. ", text: "Он приходит от дистрибьютора и появляется не мгновенно — обычно на это уходит несколько дней." },
            { bold: "Создать страницу пресейва. ", text: "Выбрать площадки, на которых будет доступно сохранение, — Яндекс Музыка, VK Музыка, Spotify, Apple Music." },
            { bold: "Проверить ссылку своими руками. ", text: "Открыть её с телефона и убедиться, что страница грузится и кнопка работает. Нерабочая ссылка обнуляет всю кампанию целиком." },
          ],
        },
        {
          type: "Description",
          text: "После выхода релиза страница пресейва автоматически превращается в обычную релизную страницу со ссылками на стриминги — отдельно ничего переделывать не нужно, и уже размещённые ссылки не придётся менять.",
        },
      ],
    },
    {
      id: "gde-rasprostranyat",
      title: "Где распространять ссылку",
      content: [
        {
          type: "Description",
          text: "Ссылка бесполезна, пока она лежит в кабинете. Места, которые дают результат, обычно одни и те же:",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ul",
          items: [
            { text: "закреплённый пост и шапка профиля в соцсетях — на весь период до релиза;" },
            { text: "описание тизера и коротких видео с фрагментом трека;" },
            { text: "рассылка по своей базе, если она есть;" },
            { text: "личные сообщения тем, кто реально слушает вас, — небольшая, но самая отзывчивая аудитория;" },
            { text: "коллаборации: репост у артистов близкого жанра работает лучше рекламы у чужой аудитории." },
          ],
        },
        {
          type: "Description",
          parts: [
            "Если своей аудитории пока мало, сохранения можно добрать заданиями живым слушателям — переход по ссылке, сохранение, просмотр профиля, прослушивание другого трека из каталога. Как это устроено и сколько стоит, описано на странице ",
            { to: "/prodvizhenie-trekov-yandexmusic-presave", text: "заказать пресейвы в Яндекс Музыке" },
            ".",
          ],
        },
      ],
    },
    {
      id: "skolko-nuzhno",
      title: "Сколько пресейвов нужно",
      content: [
        {
          type: "Description",
          text: "Официального порога не существует. Ни Яндекс Музыка, ни BandLink не публиковали число, после которого релиз попадает в рекомендации, и сервис, который такую цифру называет, её придумал.",
        },
        {
          type: "Description",
          text: "Работает не абсолютное число, а соотношение с обычной аудиторией артиста. Тридцать сохранений у артиста с сотней месячных слушателей — заметное событие. Те же тридцать у артиста с аудиторией в сто тысяч не значат почти ничего.",
        },
        {
          type: "Description",
          text: "Практическая рамка, из которой стоит исходить:",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ul",
          items: [
            { bold: "До 5 000 слушателей в месяц. ", text: "Это аудитория, которой доступно Нитро. Здесь важнее не объём, а сам факт стартовой реакции в день выхода." },
            { bold: "Растущая аудитория. ", text: "Ориентир — порядок вашей обычной аудитории релиза, а не круглые числа из чужих кейсов." },
            { bold: "Большая аудитория. ", text: "Пресейв-кампания имеет смысл как часть общей подготовки релиза, а не как отдельный инструмент." },
          ],
        },
        {
          type: "Subtotal",
          title: "Разумный способ начать",
          text: "Взять минимальный объём, посмотреть на отчёты и на то, как ведут себя цифры в кабинете на следующий день после релиза, и уже тогда планировать масштаб следующей кампании.",
        },
      ],
    },
    {
      id: "kogda-zapuskat",
      title: "Когда запускать",
      content: [
        {
          type: "Description",
          text: "У пресейв-кампании жёсткая привязка к дате выхода, и запас нужен с обеих сторон: релиз должен успеть появиться в кабинете, а задания — разойтись по исполнителям.",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ul",
          items: [
            { bold: "За 3–4 недели ", text: "— отдать релиз дистрибьютору. Официальная рекомендация — минимум две недели, но с запасом спокойнее." },
            { bold: "За 2–2,5 недели ", text: "— подать релиз на питчинг. Кнопка появляется примерно через 2–4 дня после подтверждения релиза." },
            { bold: "За 1,5–2 недели ", text: "— создать ссылку и начать её распространять, тогда же запускать кампанию." },
            { bold: "За неделю ", text: "— прогрев: тизеры, обложка, отрывки." },
          ],
        },
        {
          type: "Description",
          parts: [
            "Развёрнутый календарь с тем, что делается на каждом шаге, — в отдельной статье: ",
            { to: "/blog/kalendar-reliza", text: "что и за сколько дней нужно успеть к релизу" },
            ".",
          ],
        },
      ],
    },
    {
      id: "den-reliza",
      title: "День релиза и что после",
      content: [
        {
          type: "Description",
          text: "В день выхода сохранения срабатывают автоматически — делать для этого ничего не нужно. Дальше работает уже другая механика: слушателям, у которых релиз появился в коллекции, он попадается в ленте, и часть из них его действительно слушает.",
        },
        {
          type: "Description",
          text: "Статистику стоит смотреть с поправкой на два свойства кабинета: данные обновляются раз в сутки после 20:00 по московскому времени, а сама аналитика доступна только верифицированным артистам и только в русскоязычном интерфейсе — через VPN она не открывается. Поэтому пустая статистика вечером в день релиза ещё ничего не означает.",
        },
        {
          type: "Description",
          parts: [
            "После выхода эстафету принимают прослушивания и действия вокруг трека — это уже другая услуга: ",
            { to: "/prodvizhenie-trekov-yandexmusic", text: "продвижение треков после релиза" },
            ".",
          ],
        },
      ],
    },
    {
      id: "oshibki",
      title: "Частые ошибки",
      content: [
        {
          type: "List",
          listType: "ul",
          items: [
            { bold: "Запуск за два дня до релиза. ", text: "Ссылка ещё не готова или кампания не успевает разойтись — и весь смысл инструмента теряется." },
            { bold: "Ссылка, которую никто не проверил. ", text: "Открывается с ошибкой — задание невыполнимо, а деньги на кампанию уже распределены." },
            { bold: "Сохранения без всего остального. ", text: "Тридцать одинаковых нажатий и тридцать сохранений, вокруг которых есть переходы в профиль и прослушивания каталога, выглядят в кабинете по-разному." },
            { bold: "Ожидание цифр в тот же вечер. ", text: "Статистика обновляется раз в сутки после 20:00 по Москве." },
            { bold: "Пропущенный питчинг. ", text: "Бесплатный шаг, который забывают чаще остальных, — а для сингла он ещё и условие участия в Нитро." },
          ],
        },
        {
          type: "Description",
          parts: [
            "Отдельная тема — чем сохранения от живых слушателей отличаются от искусственных и что за них бывает по правилам дистрибьюторов: ",
            { to: "/blog/nakrutka-proslushivaniy-pravila-distributorov", text: "разбор правил TuneCore, Amuse и DistroKid" },
            ".",
          ],
        },
      ],
    },
    {
      id: "korotko",
      title: "Коротко",
      content: [
        {
          type: "List",
          listType: "ul",
          items: [
            { text: "Пресейв работает только до даты выхода: после релиза заказать его нельзя." },
            { text: "Ссылка создаётся в BandLink и требует верифицированной карточки артиста." },
            { text: "Официального порога «сколько нужно» не существует — важно соотношение с вашей обычной аудиторией." },
            { text: "Запускать кампанию стоит за 1,5–2 недели до выхода, отдав релиз дистрибьютору за 3–4 недели." },
            { text: "Сохранение вместе с переходом в профиль и прослушиванием каталога выглядит иначе, чем одно нажатие." },
            { text: "Статистика в кабинете обновляется раз в сутки после 20:00 по Москве." },
          ],
          classes: ["nomargin"],
        },
      ],
    },
  ],
};

export default article;
